import {Typography} from "@mui/material";
import {connect} from "react-redux";
import Item from "./Atoms/Item";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
  }) => ({
    i18n,
    isLoading,
  }),
  {
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  const isLoading = props.isLoading;
  return (
    <div className="card-info">
      <Typography variant="h1">{i18n.choose_subscription_title}</Typography>
      <span className="span">Alle Preise verstehen sich zzgl. 19% USt.</span>
      <Item />
    </div>
  );
});
